import React, { useState, useEffect } from 'react';
import CustomizedTables from "./Table"
import ClipLoader from 'react-spinners/ClipLoader';

function Table2({year, setloading2}){
  const [dataTable2, setdata2] = useState();

  const [excelDataTable2, setexcelDataTable2] = useState();

  function normalize_numbers(num, nOfDec=2){
    return Number((num).toFixed(nOfDec));
  }

  useEffect(() => {
    var url = "api/flights/" + year;
    fetch(url).then((res) =>
      res.json().then((res) => {
        

        var dataTable = []
        dataTable.push({"name": "Εσωτερικό", "firstYear": normalize_numbers(res.data["Εσωτερικού"][1]/1000000), "secondYear": normalize_numbers(res.data["Εσωτερικού"][0]/1000000), "difference": normalize_numbers(res.data["Εσωτερικού"][2]*100)})
        dataTable.push({"name": "Εξωτερικό", "firstYear": normalize_numbers(res.data["Εξωτερικού"][1]/1000000), "secondYear": normalize_numbers(res.data["Εξωτερικού"][0]/1000000), "difference": normalize_numbers(res.data["Εξωτερικού"][2]*100)})
        dataTable.push({"name": "Σύνολο", "firstYear":  normalize_numbers(res.data["Σύνολο"][1]/1000000), "secondYear":  normalize_numbers(res.data["Σύνολο"][0]/1000000), "difference":  normalize_numbers(res.data["Σύνολο"][2]*100)})
        
        setexcelDataTable2(dataTable);
        setdata2(dataTable);
        setloading2(false)
      })
    )
    .catch((error) => {
      console.log("Refetching data for table2!")
    });
  }, [year, setloading2]);


  


    return(
        dataTable2 ? 
        <CustomizedTables props = {dataTable2} name ={"Πτήσεις"} year = {year} excelData = {excelDataTable2}></CustomizedTables>
      :  <ClipLoader size={100} color={'#123abc'} loading={true}/>     
    )
}




export default Table2;